<template>
  <svg width="685" height="883" viewBox="0 0 685 883" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle opacity="0.6" cx="243.5" cy="441.5" r="441" stroke="white"/>
    <circle opacity="0.6" cx="243.5" cy="441.5" r="319" transform="rotate(-83.1234 243.5 441.5)" stroke="white"/>
    <circle opacity="0.6" cx="243.5" cy="441.5" r="170.549" transform="rotate(112.898 243.5 441.5)" stroke="white"/>
    <circle opacity="0.6" cx="362.5" cy="676.5" r="5" fill="white" stroke="white"/>
    <circle opacity="0.6" cx="200.5" cy="352.5" r="5" fill="white" stroke="white"/>
    <circle opacity="0.6" cx="33.5" cy="428.5" r="8" fill="white" stroke="white"/>
    <circle opacity="0.6" cx="519.5" cy="404.5" r="5" fill="white" stroke="white"/>
  </svg>
</template>

<script>
export default {};
</script>
